<template>
  <div class="notification-bar" :class="notificationTypClass">
    <p>{{ notification.message }}</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { setTimeout, clearTimeout } from "timers";

export default {
  data() {
    return {
      timeout: null
    };
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    notificationTypClass() {
      return "-text-${this.notification.type}";
    }
  },
  methods: {
    ...mapActions("notification", ["remove"])
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
</script>

<style scoped>
.notification-bar {
  margin: 1em 0 1em;
  float: right;
  padding: 5px;
}

.notification-bar p {
  color: red !important;
}
</style>
